import { useNavigate } from "react-router-dom";
import { PAGE_NAME_SELECT_OCCURRENCE_TIMING } from "../../../../constants/common_constants";
import { useDtsAppContext } from "../../../../components/provider/DtsAppContextProvider";
import { useTranslation } from "react-i18next";
import { useErrorDialog } from "../../../../hooks";

interface EngineModelNextPageButtonProps {
  disabled: boolean;
  userId: string;
  model: string;
  machineNumber?: string;
  dtcSearchData?: string;
  modelType: string;
}

// ボタン
export const EngineModelNextPageButton: React.FC<
  EngineModelNextPageButtonProps
> = ({
  disabled,
  userId,
  model,
  machineNumber,
  dtcSearchData,
  modelType,
}) => {
  // ページ遷移用
  const navigate = useNavigate();
  //言語切替用
  const { t } = useTranslation();

  const {
    setDacModel,
    setDacMachineNumber,
    setDacDtcSearchData,
    setDacModelType,
  } = useDtsAppContext();
  // エラーダイアログ
  const { showErrorDialog } = useErrorDialog();

  const handleCheckSubjectName = async () => {
    try {
      setDacModel(model);
      localStorage.setItem("model", model);
      setDacDtcSearchData(dtcSearchData ?? "");
      localStorage.setItem("dtcSearchData", dtcSearchData ?? "");
      setDacModelType(modelType ?? "");
      localStorage.setItem("modelType", modelType);
      if (machineNumber) {
        setDacMachineNumber(machineNumber);
        localStorage.setItem("machineNumber", machineNumber);
      } else {
        // 機番未入力の場合、Contextを""に更新+ローカルストレージリセット
        setDacMachineNumber("");
        localStorage.removeItem("machineNumber");
      }
      navigate(`/${PAGE_NAME_SELECT_OCCURRENCE_TIMING}`);
    } catch (err) {
      console.log("[Engine Model Selection]handleCheckSubjectName err :", err);
      if (!userId) {
        showErrorDialog(
          t("共通エラーポップ.エラー"),
          t("共通エラーポップ.通信エラーが発生しました。"),
          "navigateToTopPage"
        ); //エラー", "通信エラーが発生しました。(トップページに遷移する)
      } else if (
        err instanceof Error &&
        err.message === "Duplicated SubjectName Error"
      ) {
        showErrorDialog(
          t("共通エラーポップ.エラー"),
          t("型式選択画面.登録済みの案件名です。"),
          ""
        ); //エラー", "登録済みの案件名です。
      } else if (
        err instanceof Error &&
        (err.message === "Expired token" || err.message === "Invalid token")
      ) {
        //LocalStorageのセッション情報クリア
        const userpool_client_id =
          process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID ?? "";
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.accessToken`
        );
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.refreshToken`
        );
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.idToken`
        );
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.clockDrift`
        );
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.LastAuthUser`
        );

        showErrorDialog(
          t("共通エラーポップ.エラー"),
          t("共通エラーポップ.セッションがタイムアウトしました。"),
          "ydsyos"
        ); //エラー", "セッションがタイムアウトしました。(YDS/YOSに遷移する)
      } else {
        showErrorDialog(
          t("共通エラーポップ.エラー"),
          t("共通エラーポップ.通信エラーが発生しました。")
        ); //エラー", "通信エラーが発生しました。
      }
    }
  };

  return (
    <div>
      <button
        onClick={handleCheckSubjectName}
        disabled={disabled}
        className={`${
          !disabled
            ? "border-main-red bg-white"
            : "text-gray-500 border-gray-500 bg-gray-300"
        } rounded-full border-2 py-1 px-6 w-40 overflow-hidden whitespace-nowrap`}
      >
        <p className="font-bold text-[20px]">{t("型式選択画面.次へ")}</p>
        {/* 次へ */}
      </button>
    </div>
  );
};
